module.exports = __webpack_public_path__ + "static/media/43.6b7f7bf4.jpg";